import React from "react";
import { emptyList } from "../../constants/emptyList";
import { Trans } from "react-i18next";
import { EmptyPageProps } from "./interface";
import StorageUtil from "../../utils/serviceUtils/storageUtil";

const EmptyPage: React.FC<EmptyPageProps> = ({ mode, isCollapsed }) => {
  const isDarkMode =
    StorageUtil.getReaderConfig("appSkin") === "night" ||
    (StorageUtil.getReaderConfig("appSkin") === "system" && StorageUtil.getReaderConfig("isOSNight") === "yes");

  const backgroundGradient = isDarkMode
    ? 'linear-gradient(135deg, #1a202c 0%, #2d3748 100%)'
    : 'linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)';

  const headingGradient = isDarkMode
    ? 'linear-gradient(120deg, #e2e8f0 0%, #cbd5e0 100%)'
    : 'linear-gradient(120deg, #2d3748 0%, #4a5568 100%)';

  const dropShadow = isDarkMode
    ? 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.3))'
    : 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))';

  return (
    <div 
      className="flex justify-center items-center min-h-screen transition-all duration-300" 
      style={{ background: backgroundGradient }}
    >
      <div className="flex flex-col items-center gap-8 p-8 md:p-4 max-w-[1200px] w-full">
        <div className="relative w-full max-w-[500px] h-[300px] md:h-[250px] sm:h-[200px] mb-4">
          <img
            src={isDarkMode ? "./assets/empty_light.svg" : "./assets/empty.svg"}
            alt=""
            className="w-full h-full object-contain transition-transform duration-300 hover:scale-105"
            style={{ filter: dropShadow }}
          />
          <p className="text-lg text-gray-600 dark:text-gray-300 mt-4 font-medium text-center opacity-80"><Trans>No items to display</Trans></p>
        </div>

        <div className="text-center w-full max-w-[600px]">
          {emptyList.map((item) => (
            <div 
              className={`transition-all duration-300 ${
                mode === item.mode 
                  ? 'opacity-100 visible translate-y-0 relative' 
                  : 'opacity-0 invisible translate-y-5 absolute w-full'
              }`} 
              key={item.mode}
            >
              <h2 
                className="text-4xl md:text-3xl sm:text-[1.75rem] font-bold mb-4" 
                style={{ 
                  background: headingGradient,
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}
              >
                <Trans>{item.main}</Trans>
              </h2>
              <p className="text-xl md:text-lg sm:text-base text-gray-600 dark:text-gray-300 leading-relaxed m-0 font-normal">
                <Trans>{item.sub}</Trans>
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmptyPage;
